module.exports = __webpack_public_path__ + "img/personimg.3747edc0.png";